export default function () {
  try {
    const btns = document.querySelectorAll(".js-mobile-panel-chapt");
    const blocks = document.querySelectorAll("[data-chapt-block]");

    clear_btns();
    clear_blocks();

    active_chapt(btns[0]);

    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        clear_btns();
        clear_blocks();
        active_chapt(btn);
      });
    });
    //

    function active_chapt(btn) {
      btn.classList.add("active");
      let path = btn.getAttribute("data-chapt-btn");

      let block = document.querySelector(`[data-chapt-block=${path}]`);
      block.classList.add("active");
    }

    function clear_btns() {
      btns.forEach((btn) => btn.classList.remove("active"));
    }

    function clear_blocks() {
      blocks.forEach((block) => block.classList.remove("active"));
    }
  } catch (e) {}
}
